import React from 'react';

import { cn } from '@/lib/utils';

export interface FullLayoutHeaderProps extends React.ComponentPropsWithoutRef<'header'> {
  onOpenLeft?: () => void;
  onOpenRight?: () => void;
}

const FullLayoutHeader = React.forwardRef<HTMLElement, FullLayoutHeaderProps>(
  ({ onOpenLeft, onOpenRight, className, children, ...props }, ref) => {
    return (
      <header
        ref={ref as React.Ref<HTMLHeadingElement>}
        data-slot="full-layout-header"
        className={cn('h-16 bg-white shadow-md flex items-center px-4 shrink-0 sticky top-0 z-20', className)}
        {...props}
      >
        {onOpenLeft != null && (
          <button
            data-slot="full-layout-header-trigger-left"
            type="button"
            onClick={onOpenLeft}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors mr-4 lg:hidden"
            aria-label="Toggle menu"
          >
            <svg className="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        )}
        <div data-slot="full-layout-header-center" className="flex-1 min-w-0">
          {children}
        </div>
        {onOpenRight != null && (
          <div data-slot="full-layout-header-trigger-right" className="ml-auto">
            <button
              type="button"
              onClick={onOpenRight}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
              aria-label="Toggle chat"
            >
              <svg className="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                />
              </svg>
            </button>
          </div>
        )}
      </header>
    );
  },
);

FullLayoutHeader.displayName = 'FullLayoutHeader';

export { FullLayoutHeader };
